import { cartLineKey } from '../utils/cartUtils';

export default (state, action) => {
  switch (action.type) {
    default:
      return state;

    case 'LOAD_PRODUCT_LIST':
      return {
        ...state,
        productList: [...state.productList, ...action.payload]
      };

    case 'CLEAR_PRODUCT_LIST':
      return {
        ...state,
        productList: []
      };

    case 'LOAD_PRODUCT_SEARCH_LIST':
      return {
        ...state,
        searchList: [...state.searchList, ...action.payload]
      };

    case 'CLEAR_PRODUCT_SEARCH_LIST':
      return {
        ...state,
        searchList: []
      };

    case 'CLEAR_CART_LIST':
      return {
        ...state,
        cartList: []
      };

    // Same product, same variation → bump the quantity. Same product, different size → a new line.
    // Matching is by `cartLineKey`, never by object identity: see utils/cartUtils.js.
    case 'ADD_CART_ITEM': {
      const newCartItm = action.payload[0];
      const newKey = cartLineKey(newCartItm);
      const existingItem = state.cartList.find((item) => cartLineKey(item) === newKey);

      if (!existingItem) {
        return {
          ...state,
          cartList: [...state.cartList, ...action.payload]
        };
      }
      return {
        ...state,
        cartList: state.cartList.map((item) =>
          cartLineKey(item) === newKey
            ? { ...item, quantity: item.quantity + newCartItm.quantity }
            : item
        )
      };
    }

    case 'REMOVE_CART_ITEM': {
      const removeKey = cartLineKey(action.payload);
      return {
        ...state,
        cartList: state.cartList.filter((item) => cartLineKey(item) !== removeKey)
      };
    }

    case 'SELECT_DELIVERY_OPTION':
      return {
        ...state,
        shippingOption: action.payload
      };

    case 'SET_CATEGORY_ID_URL_PARAM':
      return {
        ...state,
        categoryIdUrlParam: action.payload
      };

    case 'SET_SUBCATEGORY_ID_URL_PARAM':
      return {
        ...state,
        subcategoryIdUrlParam: action.payload
      };

    case 'SET_MATERIAL_ID_URL_PARAM':
      return {
        ...state,
        materialIdUrlParam: action.payload
      };

    case 'SET_PRODUCT_FILTER_KEY':
      return {
        ...state,
        productFilterKey: action.payload
      };

    case 'SET_PAGE_URL_PARAM': {
      return {
        ...state,
        pageUrlParam: action.payload
      };
    }

    case 'SET_SIZE_URL_PARAM': {
      return {
        ...state,
        sizeUrlParam: action.payload
      };
    }

    case 'SET_TERM_PARAM': {
      return {
        ...state,
        termParam: action.payload
      };
    }

    case 'SET_MENU': {
      let menuPayload = action.payload;
      for (var key in menuPayload) {
        menuPayload[key]['subCategories'].sort(function (a, b) {
          return a.position - b.position;
        });
      }
      return {
        ...state,
        menu: menuPayload
      };
    }

    case 'SET_MATERIAL_CATEGORIES': {
      return {
        ...state,
        materialCategories: action.payload
      };
    }

    // The id alone is not enough: one product can sit in the cart several times in different
    // sizes, so the quantity stepper has to address a single line.
    case 'CHANGE_CART_ITEM_QTY': {
      const cartItem = action.payload;
      const targetKey = cartLineKey(cartItem);
      const exist = state.cartList.find((item) => cartLineKey(item) === targetKey);

      if (cartItem.quantity < 1 && exist) {
        return {
          ...state,
          cartList: state.cartList.filter((item) => cartLineKey(item) !== targetKey)
        };
      }
      if (exist) {
        return {
          ...state,
          cartList: state.cartList.map((item) =>
            cartLineKey(item) === targetKey ? { ...item, quantity: cartItem.quantity } : item
          )
        };
      }
      return {
        ...state,
        cartList: [...state.cartList, cartItem]
      };
    }
  }
};
